<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.phone" placeholder="请输入运营中心手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secah.operationCenterName" placeholder="请输入运营中心名称"></el-input>
        </el-form-item>
        <el-form-item label="运营商级别" label-width='100px'>
          <el-select clearable v-model="secah.level" placeholder="请选择运营商级别">
            <el-option label="全部" value=""></el-option>
            <el-option label="省级运营商" :value="1"></el-option>
            <el-option label="市级运营商" :value="2"></el-option>
            <el-option label="区级运营商" :value="3"></el-option>
            <el-option label="技术运营商" :value="4"></el-option>
            <el-option label="核心运营商" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" label-width='100px'>
          <el-select clearable v-model="secah.state" placeholder="请选择审核状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核不通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click='setyysShow = true'>运营商赠送比例</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="level" label="级别" align="center">
          <template slot-scope="scope">
            {{getLevel(scope.row.level)}}
          </template>
        </el-table-column>
        <el-table-column prop="operationCenterName" label="运营中心名称" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="agentProvince" label="代理省份" align="center"></el-table-column>
        <el-table-column prop="agentCity" label="代理城市" align="center"></el-table-column>
        <el-table-column prop="agentRegion" label="代理地区" align="center"></el-table-column>
        <el-table-column prop="businessLicense" label="营业执照" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.businessLicense" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="environmentPic" label="店内环境图" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.environmentPic" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="frontFigurePic" label="门脸图" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.frontFigurePic" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="idCardNegative" label="身份证反面照" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.idCardNegative" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="idCardPositive" label="身份证正面照" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.idCardPositive" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="shopProvince" label="店铺省份" align="center"></el-table-column>
        <el-table-column prop="shopCity" label="店铺城市" align="center"></el-table-column>
        <el-table-column prop="shopRegion" label="店铺地区" align="center"></el-table-column>
        <el-table-column prop="shopDetailAddress" label="店铺详细地址" align="center"></el-table-column>
        <el-table-column prop="locationPic" label="定位截图" align="center">
          <template slot-scope="scope">
            <img :src="webUrl + scope.row.locationPic" style="height: 60px">
          </template>
        </el-table-column>
        <el-table-column prop="state" label="申请状态" align="center">
          <template slot-scope="scope">
            {{getState(scope.row.state)}}
          </template>
        </el-table-column>
        <el-table-column prop="cancelState" label="注销状态" align="center">
          <template slot-scope="scope">
            {{scope.row.cancelState == 0 ? '未注销' : '强制注销'}}
          </template>
        </el-table-column>
        <el-table-column prop="disableState" label="禁用状态" align="center">
          <template slot-scope="scope">
            {{scope.row.disableState == 0 ? '未禁用' : '已禁用'}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button style="margin-bottom:10px" type="success" size="mini" @click="detail(scope.row)">详情</el-button>
            <el-button style="margin-bottom:10px" type="success" v-if="scope.row.state==0" size="mini" @click="refuseWithdrawal(scope.row, 1)">申请通过</el-button>
            <el-button style="margin-bottom:10px" type="danger" v-if="scope.row.state==0" size="mini" @click="refuseWithdrawal(scope.row, 2)">拒绝申请</el-button>
            <el-button style="margin-bottom:10px" type="danger" v-if="scope.row.cancelState==0" size="mini" @click="del(scope.row)">强制注销</el-button>
            <el-button style="margin-bottom:10px" type="danger" v-if="scope.row.disableState==0" size="mini" @click="disable(scope.row, 1)">禁用</el-button>
            <el-button style="margin-bottom:10px" type="success" v-if="scope.row.disableState==1" size="mini" @click="disable(scope.row, 0)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="运营商赠送比例" :visible.sync="setyysShow" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="省级运营商赠送比例" label-width='150px'>
          <el-input type="text" v-model="setyysInfo.provincePresentProportion" maxlength="10" autocomplete="off" placeholder="省级运营商赠送比例N‰的N">
          </el-input>
          <span>每日所属区域线下有效积分xN‰（默认1）</span>
        </el-form-item>
        <el-form-item label="市级运营商赠送比例" label-width='150px'>
          <el-input type="text" v-model="setyysInfo.cityPresentProportion" maxlength="10" autocomplete="off" placeholder="市级运营商赠送比例N‰的N">
          </el-input>
          <span>每日所属区域线下有效积分xN‰（默认2）</span>
        </el-form-item>
        <el-form-item label="区级运营商赠送比例" label-width='150px'>
          <el-input type="text" v-model="setyysInfo.regionPresentProportion" maxlength="10" autocomplete="off" placeholder="区级运营商赠送比例N‰的N">
          </el-input>
          <span>每日所属区域线下有效积分xN‰（默认9）</span>
        </el-form-item>
        <el-form-item label="技术运营商赠送比例" label-width='150px'>
          <el-input type="text" v-model="setyysInfo.technologyPresentProportion" maxlength="10" autocomplete="off" placeholder="技术运营商赠送比例N‰的N">
          </el-input>
          <span>每日线上有效积分xN‰（默认3）</span>
        </el-form-item>
        <el-form-item label="核心运营商赠送比例" label-width='150px'>
          <el-input type="text" v-model="setyysInfo.corePresentProportion" maxlength="10" autocomplete="off" placeholder="核心运营商赠送比例N‰的N">
          </el-input>
          <span>每日线上有效积分xN‰（默认7）</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setyysShow = false">取 消</el-button>
        <el-button type="primary" @click="setyysConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="审核原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="审核原因" label-width='80px'>
          <el-input type="textarea" v-model="reason" autocomplete="off" placeholder="请输入审核原因">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isreason = false">取 消</el-button>
        <el-button type="primary" @click="sub">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="详情" :visible.sync="isDetails" :modal-append-to-body='false' width="800px">

      <el-descriptions :column='2'>
        <el-descriptions-item label="运营中心名称">{{handleRow.operationCenterName}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{handleRow.phone}}</el-descriptions-item>
        <el-descriptions-item label="代理省份">{{handleRow.agentProvince}}</el-descriptions-item>
        <el-descriptions-item label="代理城市">{{handleRow.agentCity}}</el-descriptions-item>
        <el-descriptions-item label="代理地区">{{handleRow.agentRegion}}</el-descriptions-item>
        <el-descriptions-item label="店铺省份">{{handleRow.shopProvince}}</el-descriptions-item>
        <el-descriptions-item label="店铺城市">{{handleRow.shopCity}}</el-descriptions-item>
        <el-descriptions-item label="店铺地区">{{handleRow.shopRegion}}</el-descriptions-item>
        <el-descriptions-item label="店铺详细地址">{{handleRow.shopDetailAddress}}</el-descriptions-item>
        <el-descriptions-item label="申请状态">{{getState(handleRow.state)}}</el-descriptions-item>
        <el-descriptions-item label="注销状态">{{handleRow.cancelState == 0 ? '未注销' : '已注销'}}</el-descriptions-item>
      </el-descriptions>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span>营业执照</span>
          <viewer>
            <img :src="webUrl+handleRow.businessLicense" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
        <div style="flex: 1;display: flex;">
          <span>店内环境图</span>
          <viewer>
            <img :src="webUrl+handleRow.environmentPic" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span>门脸图</span>
          <viewer>
            <img :src="webUrl+handleRow.frontFigurePic" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
        <div style="flex: 1;display: flex;">
          <span>身份证正面照</span>
          <viewer>
            <img :src="webUrl+handleRow.idCardPositive" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1;display: flex;">
          <span>身份证反面照</span>
          <viewer>
            <img :src="webUrl+handleRow.idCardNegative" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
        <div style="flex: 1;display: flex;">
          <span>定位截图</span>
          <viewer>
            <img :src="webUrl+handleRow.locationPic" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      isreason: false,
      reason: '',
      secah: {
        pageSize: 10,
        pageNum: 1,
        operationCenterName: '',
        phone: '',
        level: '',
        cancelState: '',
      },
      handleRow: {},
      handleState: '',
      isDetails: false,
      setyysShow: false,
      setyysInfo: {
        provincePresentProportion: '',
        cityPresentProportion: '',
        corePresentProportion: '',
        regionPresentProportion: '',
        technologyPresentProportion: '',
      }
    }
  },
  created() {
    this.getList()
    this.getYysInfo()
  },
  methods: {
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    getLevel(level) {
      if (level == 1) {
        return '省级运营商'
      } else if (level == 2) {
        return '市级运营商'
      } else if (level == 3) {
        return '区级运营商'
      } else if (level == 4) {
        return '技术运营商'
      } else if (level == 5) {
        return '核心运营商'
      }
    },
    getState(state) {
      if (state == 0) {
        return '待审核'
      } else if (state == 1) {
        return '审核通过'
      } else if (state == 2) {
        return '审核不通过'
      }
    },
    //拒绝通过商家审核
    refuseWithdrawal(row, handleState) {
      this.isreason = true
      this.handleRow = row
      this.handleState = handleState
      this.reason = ''
    },
    //确定拒绝通过商家审核
    sub() {
      let params = {
        id: this.handleRow.id,
        remark: this.reason,
        state: this.handleState,
      }
      this.httpPost('/admin/operation/partner/audit', params, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success('审核成功')
          this.isreason = false
          this.isDetails = false
          this.getList()
        }
      })
    },
    del(row) {
      this.$confirm('确定强制注销该运营商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost('/admin/operation/partner/cancel/' + row.id).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success('注销成功')
                this.getList()
              }
            }
          )
        })
        .catch(() => {})
    },
    disable(row, disableState) {
      this.$confirm('确定' + (disableState == 0 ? '启用' : '禁用') + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost('/admin/operation/partner/disable/' + row.id + '/' + disableState).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success((disableState == 0 ? '启用' : '禁用') + '成功')
                this.getList()
              }
            }
          )
        })
        .catch(() => {})
    },
    detail(row) {
      this.handleRow = row
      this.isDetails = true
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    getYysInfo() {
      this.httpGet('/admin/operation/partner/getProportion').then((res) => {
        if (res.code == 200 && res.data) {
          this.setyysInfo = res.data
        }
      })
    },
    //获取数据
    getList() {
      var secah = this.secah
      this.httpGet('/admin/operation/partner/list', secah, true).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    },
    setyysConfirm() {
      if(!this.setyysInfo.cityPresentProportion ||
      !this.setyysInfo.corePresentProportion ||
      !this.setyysInfo.provincePresentProportion ||
      !this.setyysInfo.regionPresentProportion ||
      !this.setyysInfo.technologyPresentProportion) {
        this.$message.error('请完善信息')
        return
      }
      this.$confirm('确定修改运营商赠送比例吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost('/admin/operation/partner/updateProportion', this.setyysInfo, true, {
        'Content-Type': 'application/json',
      }).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success('修改成功')
                this.setyysShow = false
              }
            }
          )
        })
        .catch(() => {})
    }
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
